export function mapValueToColor(value: number): string {
  if (value < 0 || value > 100) {
    throw new Error('Value must be between 0 and 100')
  } else if (value < 50) {
    // Red to yellow gradient
    const red = 200
    const green = Math.round((180 * value) / 50)
    const blue = 0
    return `rgb(${red}, ${green}, ${blue})`
  } else {
    // Yellow to green gradient
    const red = Math.round(200 - (200 * (value - 50)) / 50)
    const green = 180
    const blue = 0
    return `rgb(${red}, ${green}, ${blue})`
  }
}
